var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#F4A621",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m149 403 31-28c7-6 15-9 23-9s17 3 23 9l31 28c1 1 1 1 2 1h2c1 0 1 0 2-1 0 0 1-1 1-2l10-40c3-9 8-16 15-20 7-5 16-7 24-5l41 7h2c1 0 2-1 2-1 1-1 1-2 1-2v-2l-13-40c-3-9-2-17 2-25 3-7 9-14 17-17l39-16 1-1c1-1 1-2 1-3v-2l-1-1-33-27c-6-5-11-13-12-21s1-17 6-24l24-35v-4c0-1-1-1-2-2h-1l-42-5c-9-1-17-5-22-12-5-6-8-14-8-23l1-42v-2c-1 0-1-1-2-1 0-1-1-1-2-1h-2l-37 19c-8 4-17 4-25 2s-15-7-20-15L207 4c-1-1-1-1-2-1 0-1-1-1-2-1s-1 0-2 1c0 0-1 0-1 1l-22 36c-4 8-12 13-19 15-8 2-17 2-25-2L96 34h-2s-1 0-2 1l-1 1c-1 1-1 2-1 2l2 42c0 9-3 17-9 23-5 7-13 11-22 12l-41 5h-2c-1 1-1 1-1 2-1 1-1 1-1 2s0 2 1 2l24 35c5 7 6 16 5 24s-5 16-12 21L2 233c-1 0-1 1-2 1v2c0 1 0 2 1 3 0 0 1 0 2 1l38 16c8 3 14 10 18 17 3 8 4 16 1 25l-13 40v2s1 1 1 2c1 0 1 1 2 1h2l41-7c9-2 17 0 24 5 7 4 13 11 15 20l11 40v2c1 1 2 1 2 1h3s1 0 1-1zm144-197c0-25-10-47-27-63-16-16-38-27-63-27s-47 11-63 27c-17 16-27 38-27 63s10 47 27 64c16 16 38 26 63 26s47-10 63-26c17-17 27-39 27-64zm-15-75c20 19 32 46 32 75 0 30-12 56-32 76-19 19-46 31-75 31s-56-12-76-31c-19-20-31-46-31-76 0-29 12-56 31-75 20-20 47-32 76-32s56 12 75 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/LightTheme.1099ce27a5aa63c20d71b3899026a608.svg";
export { ForwardRef as ReactComponent };